import React from 'react';
import { SectionLayout } from '../../components/Layouts';

import * as T from '../../components/Typography';
import composeStyle from '../../utils/composeStyle';

const Description = composeStyle(T.H2, 'H3', 'H4');
const Title = composeStyle(T.H4Bold, 'H4Caps', 'H5Caps');

const VisionAndMission = ({ title, description, bgcolor }) => {
  return (
    <SectionLayout id={title.includes('VISION') ? 'our-vision' : 'our-mission'} bgcolor={bgcolor}>
      <Title color="white" caps>
        {title}
      </Title>
      <Description color="white" mt={3} as="pre" style={{ width: '100%' }}>
        {description}
      </Description>
    </SectionLayout>
  );
};

export default VisionAndMission;
